export const DISTRICTS = [
  { id: 1, localisation: "Ambatofinandrahana" },
  { id: 2, localisation: "Amparafaravola" },
  { id: 3, localisation: "Andilamena" },
  { id: 4, localisation: "Ankazobe" },
  { id: 5, localisation: "Anjozorobe" },
  { id: 6, localisation: "Befandriana nord" },
  { id: 7, localisation: "Benenitra" },
  { id: 8, localisation: "Fenoarivo Est" },
  { id: 9, localisation: "Isandra" },
  { id: 10, localisation: "Lalangina" },
  { id: 11, localisation: "Maevatanana" },
  { id: 12, localisation: "Manjakandriana" },
  { id: 13, localisation: "Miarinarivo" },
  { id: 14, localisation: "Soavinandriana" },
  { id: 15, localisation: "Vohibato" },
];
